var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFillPause(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 99.63 99.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00678c;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_9",
    "data-name": "Layer 9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M99.63,49.81A49.82,49.82,0,1,0,49.81,99.63,49.81,49.81,0,0,0,99.63,49.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M43.37,65.48a6.25,6.25,0,0,1-12.5,0V34.14a6.25,6.25,0,0,1,12.5,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M68.76,65.48a6.25,6.25,0,0,1-12.5,0V34.14a6.25,6.25,0,0,1,12.5,0Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFillPause);
export default __webpack_public_path__ + "static/media/fill-pause.462ca7bd7817e5484c4751cceaf2d960.svg";
export { ForwardRef as ReactComponent };